import _ from 'lodash';

function AccountsPrivacyCtrl($scope, $state, $timeout, $window, $sce, toastr, AppSettings, UserService, PlayerService, CommonService) {
  'ngInject';




}

export default {
  name: 'AccountsPrivacyCtrl',
  fn: AccountsPrivacyCtrl
};
